import Vue from "vue"
import store from "@/store"

var getQueryString = function(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
    return null
}
var parseUbb = function(str) {
    str = str.replace(/</gi, "&lt;")
    str = str.replace(/>/gi, "&gt;")
    str = str.replace(/\s\n\s/gi, "")
    str = str.replace(/\n/gi, "<br/>")
    str = str.replace(/\s↵\s/gi, "")
    str = str.replace(/↵↵/gi, "<br/>")
    str = str.replace(/\[code\](.+?)\[\/code\]/gi, function($1, $2) {
        return phpcode($2)
    })

    str = str.replace(/\[hr\]/gi, "<hr />")
    str = str.replace(/\[\/(size|color|font|backcolor)\]/gi, "</font>")
    str = str.replace(/\[(sub|sup|u|i|strike|b|blockquote|li)\]/gi, "<$1>")
    str = str.replace(/\[\/(sub|sup|u|i|strike|b|blockquote|li)\]/gi, "</$1>")
    str = str.replace(/\[\/align\]/gi, "</p>")
    str = str.replace(/\[(\/)?h([1-6])\]/gi, "<$1h$2>")

    str = str.replace(
        /\[align=(left|center|right|justify)\]/gi,
        '<p align="$1">'
    )
    str = str.replace(/\[size=(\d+?)\]/gi, '<font size="$1">')
    str = str.replace(/\[color=([^\[\<]+?)\]/gi, '<font color="$1">')
    str = str.replace(
        /\[backcolor=([^\[\<]+?)\]/gi,
        '<font style="background-color:$1">'
    )
    str = str.replace(/\[font=([^\[\<]+?)\]/gi, '<font face="$1">')
    str = str.replace(
        /\[list=(a|A|1)\](.+?)\[\/list\]/gi,
        '<ol type="$1">$2</ol>'
    )
    str = str.replace(/\[(\/)?list\]/gi, "<$1ul>")

    str = str.replace(/\[s:(\d+)\]/gi, function($1, $2) {
        return smilepath($2)
    })

    str = str.replace(
        /\[img\]([^\[]*)\[\/img\]/gi,
        '<img src="$1" border="0" width="100%" />'
    )
    str = str.replace(
        /\[underline\]([^\[]*)\[\/underline\]/gi,
        '<p style="text-decoration:underline">' + "$1" + "</p>"
    )
    str = str.replace(
        /\[supplement timestamp=([^\[]*)\]([^\[]*)\[\/supplement\]/gi,
        "$2"
    )
    str = str.replace(
        /\[url=([^\]]+)\]([^\[]+)\[\/url\]/gi,
        '<a href="$1">' + "$2" + "</a>"
    )
    str = str.replace(
        /\[url\]([^\[]+)\[\/url\]/gi,
        '<a href="$1">' + "$1" + "</a>"
    )
    str = str.replace(
        /\[url href=([^\]]+)\]([^\[]+)\[\/url\]/gi,
        '<a href=$1 display="block">' + "$2" + "</a>"
    )
    str = str.replace(
        /\[test.*?\]([^\[]*)\[\/test\]/gi,
        '<span style="color:#72b9c3">' + "$1" + "</span>"
    )
    str = str.replace(
        /\[disease.*?\]([^\[]*)\[\/disease\]/gi,
        '<span style="color:#72b9c3">' + "$1" + "</span>"
    )
    return str
}
var isService = function() {
    // 查看有没有关注服务号
    if (
        (GLOBAL.getInfo("ExpiryDate") == null && !GLOBAL.getInfo("isFollow")) ||
        GLOBAL.getInfo("ExpiryDate") <= Date.parse(new Date()) ||
        !store.state.session.isService
    ) {
        Vue.http
            .get(`${store.state.origin}/api/user/serviceaccount/subscription`)
            .then(res => {
                if (res.body.status.error == 0) {
                    store.state.session.isService = true
                    let subscription = res.body.result.subscription
                    if (!subscription) {
                        store.state.session.isShowServiceQuery = true
                        if (
                            GLOBAL.getInfo("ExpiryDate") != null &&
                            GLOBAL.getInfo("ExpiryDate") >= Date.parse(new Date())
                        ) {
                            store.state.session.isShowServiceMain = false
                        } else {
                            store.state.session.isShowServiceMain = true
                        }
                        GLOBAL.setInfo("isFollow", false)
                    } else {
                        store.state.session.isShowServiceQuery = false
                        store.state.session.isShowServiceMain = false
                        GLOBAL.setInfo("isFollow", true)
                        if (GLOBAL.getInfo("ExpiryDate") != null) {
                            GLOBAL.removeInfo("ExpiryDate")
                        }
                    }
                }
            })
            .catch(error => { })
    }
}
// 随机位数字符串
function randomString(e) {
    e = e || 32
    var t = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-.~!@#$%^&*()_:<>?',
        a = t.length,
        n = ""
    for (var i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
    return n
}
export { getQueryString, parseUbb, isService,randomString }



// WEBPACK FOOTER //
// ./src/common/js/util.js